import React from 'react';
import { CheckIcon, CreditCardIcon } from 'lucide-react';
import { PRICE, PRODUCT_IMAGE, offerIncludes, offerRows } from '../data/content';
import { CtaButton } from './CtaButton';
export function Offer() {
  return <section id="offer" className="w-full bg-slate-900 px-5 py-24 text-stone-50 sm:px-14 sm:py-32" data-id="element-226" data-mp="1mmh6abszb4gw">
      <div className="mx-auto grid max-w-6xl gap-14 lg:grid-cols-12 lg:items-center" data-id="element-227" data-mp="1hph2y8nikfth">
        <div className="px-3 sm:px-0 lg:col-span-6" data-id="element-228" data-mp="ty1vk1gvr8bd">
          <h2 className="font-serif text-[2.6rem] leading-[1.02] tracking-tight sm:text-6xl" data-id="element-229" data-mp="u0xvtwg7a92z">
            你的完整 <em className="text-red-300" data-id="element-230" data-mp="p1uvuqf2ut1v">體育備課寶™</em> 教材套裝
          </h2>
          <p className="mt-6 max-w-md text-lg leading-relaxed text-stone-50/70" data-id="element-231" data-mp="13ym0be3lyuyc">
            5 分鐘備好一整個學年的體育課。
          </p>
          <img src={PRODUCT_IMAGE} alt="" className="mx-auto mt-12 hidden w-full max-w-sm drop-shadow-2xl lg:block" data-id="element-232" data-mp="z0103eocwb9w" />
        </div>

        <div id="offer-card" className="scroll-mt-16 rounded-3xl bg-stone-50 p-6 text-slate-900 shadow-2xl shadow-black/40 sm:p-11 lg:col-span-6" data-id="element-233" data-mp="2add3xpk48tw2">
          <p className="text-sm font-semibold text-slate-900/60" data-id="element-234" data-mp="pjpdu8g8tctm">完整套裝包括</p>

          <ul className="mt-5 divide-y divide-slate-900/10 border-y border-slate-900/10" data-id="element-235" data-mp="ui8ze7qxcmlg">
            {offerRows.map(row => <li key={row.label} className="flex gap-4 py-4" data-id="element-236" data-mp="zjpufmmq9eu4">
                <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-red-700" data-id="element-237" data-mp="13ki6enmzhxu3">
                  <CheckIcon className="h-3 w-3 text-white" strokeWidth={3} aria-hidden="true" data-id="element-238" data-mp="6usgfvpju476" />
                </span>
                <span data-id="element-239" data-mp="btc2dw457fzj">
                  <span className="block font-medium leading-snug" data-id="element-240" data-mp="bqpyc6ggnim2">{row.label}</span>
                  <span className="mt-0.5 block text-sm leading-snug text-slate-900/65" data-id="element-241" data-mp="ft4e2hou2294">{row.detail}</span>
                </span>
              </li>)}
          </ul>

          <div className="mt-8 flex flex-col items-center gap-2 text-center sm:flex-row sm:items-end sm:justify-between sm:gap-4 sm:text-left" data-id="element-242" data-mp="3k9fau432x8ox">
            <p className="text-sm font-medium text-slate-900/70 sm:pb-2" data-id="element-243" data-mp="3o84m9r4k4g5x">推廣價</p>
            <p className="font-serif text-7xl leading-none tracking-tight text-slate-900 sm:text-8xl" data-id="element-244" data-mp="ve60y811zls8">
              {PRICE}
            </p>
          </div>
          <p className="mt-3 flex items-center justify-center gap-2 text-sm text-slate-900/70 sm:justify-end" data-id="element-245" data-mp="15620zomp9lz3">
            <CreditCardIcon className="h-4 w-4" aria-hidden="true" data-id="element-246" data-mp="10678xhr6uqcg" />
            一次付款，無需訂閱。
          </p>

          <CtaButton label="立即取得完整套裝" className="mt-8 w-full" data-id="element-247" data-mp="chxtcxkkiytr" />

          <ul className="mt-5 flex flex-wrap justify-center gap-x-4 gap-y-1 text-xs text-slate-900/60" data-id="element-248" data-mp="7hrzdaqtt08i">
            {offerIncludes.map(item => <li key={item} data-id="element-249" data-mp="lht79a5id7xh">{item}</li>)}
          </ul>
        </div>
      </div>
    </section>;
}